Vendd.Scripts.load(function () {
    'use strict';

    var clientIP = Cookies.get('ClientIP');

    if (!clientIP) {
        fetchWithTimeout('https://v6.api64.lighthouse.gr?format=json', 3000)
            .then(function (response) { return response.json(); })
            .catch(function () {
                return fetchWithTimeout('https://api64.lighthouse.gr?format=json', 3000)
                    .then(function (response) { return response.json(); });
            })
            .then(function (data) {
                Cookies.set('ClientIP', data.ip, { samesite: 'Lax' });
            })
            .catch(function (error) { console.error(error); });
    }

    function fetchWithTimeout(url, timeoutMs) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, timeoutMs);
        return fetch(url, { signal: controller.signal }).finally(function () {
            clearTimeout(timer);
        });
    }
});